module.exports = __webpack_public_path__ + "img/BLANCO_Support.1621cd9f.png";